import React, { createContext, useContext, useState, ReactNode } from 'react';

interface CategoryContextType {
  selectedCategoryId: string;
  setSelectedCategoryId: (id: string) => void;
  selectedCategoryName: string;
  setSelectedCategoryName: (name: string) => void;
}

const CategoryContext = createContext<CategoryContextType | undefined>(undefined);

export const CategoryProvider = ({ children }: { children: ReactNode }) => {
  const [selectedCategoryId, setSelectedCategoryId] = useState<string>('');
  const [selectedCategoryName, setSelectedCategoryName] = useState<string>('All');

  return (
    <CategoryContext.Provider
      value={{
        selectedCategoryId,
        setSelectedCategoryId,
        selectedCategoryName,
        setSelectedCategoryName,
      }}
    >
      {children}
    </CategoryContext.Provider>
  );
};

export const useCategory = () => {
  const context = useContext(CategoryContext);
  if (context === undefined) {
    throw new Error('useCategory must be used within a CategoryProvider');
  }
  return context;
};
